module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/business-calculator/business-gate/business-gate.component.css
// module id = ./src/app/components/calculator/calculator-item/business-calculator/business-gate/business-gate.component.css
// module chunks = main